module.exports = __webpack_public_path__ + "img/814.08ff41a8.png";